import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { ASSET_TYPE_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import AssetTypeDialog from "./AssetTypeDialog";
import Tooltip from "@mui/material/Tooltip"

function AssetType() {

  const [assetTypeData, setAssetTypeData] = useState([]);

  useEffect(() => {
    getAssetTypes();
  }, []);


  const getAssetTypes = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(ASSET_TYPE_URL).then((response) =>
      setAssetTypeData(response.data.data)
    );
  };

  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <AssetTypeDialog
          assetTypeId={0}
          selectedTypeName={""}
          callAssetTypes={getAssetTypes}
          actionType={"Add"}
          isEdit={false}
        />
      </Box>
      <AppTableView
        rows={assetTypeData}
        initialPageSize={15}
        cols={[
          {
            field: "name", headerName: "Type Name", flex: 1, renderCell: (params) => {
              return (
                <AssetTypeDialog
                  assetTypeId={params.row.id}
                  selectedTypeName={params.value}
                  callAssetTypes={getAssetTypes}
                  actionType={"Edit"}
                  isEdit={true}
                />
              );
            }
          },
          {
            field: "assetClass",
            headerName: "Asset Class",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => params.value?.name,
          },
          {
            field: "description",
            headerName: "Description",
            flex: 2,
            minWidth: 200,
            renderCell: (params) => {
              return <Tooltip title={params.value}>{params.value}</Tooltip>
            },
          },
          {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => {
              const statusColors = {
                false: "error",
                true: "success",
              };
              return (
                <Chip
                  label={params.value ? "Active" : "Inactive"}
                  color={statusColors[params.value]}
                  size="small"
                />
              );
            },
          },
        ]}
        hasRowSelectableFn={() => true}
        handleRowSelection={() => { }}
        checkboxSelection={false}
      />
    </Container>
  );
}

export default AssetType;
